module.exports = {"650422100":"托克逊镇","650422101":"库米什镇","650422102":"克尔碱镇","650422103":"阿乐惠镇","650422104":"伊拉湖镇","650422105":"夏镇","650422106":"博斯坦镇","650422201":"郭勒布依乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650422.json
// module id = 3205
// module chunks = 0